import { render, staticRenderFns } from "./GeneralSponsor.vue?vue&type=template&id=558c7f58&scoped=true&"
import script from "./GeneralSponsor.vue?vue&type=script&lang=js&"
export * from "./GeneralSponsor.vue?vue&type=script&lang=js&"
import style0 from "./GeneralSponsor.vue?vue&type=style&index=0&id=558c7f58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558c7f58",
  null
  
)

component.options.__file = "GeneralSponsor.vue"
export default component.exports